import { render } from "./SingleSelection.vue?vue&type=template&id=1118f47a"
import script from "./SingleSelection.vue?vue&type=script&lang=js"
export * from "./SingleSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__